import React,{useState,useEffect} from 'react';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import Ajax from './Ajax';
import {Inc,Play,EventParam} from "./Inc";
import {Styles} from './Styles';
import {Tools} from './Tools';
import Loading from './Loading';
import FourMeters from './FourMeters';
import Parameter from './Parameter';

interface Props {
    play:Play,
    param:EventParam,
    close(play:Play):void,
    gold(num:number):void,
}

let selectedIndex = 0;

const EventMachine = (props:Props)=> {
    const classes = Styles.base();
    const [states,setStates] = useState({
        newPlay: Inc.defaultPlay(),
        selected: false,
        finished: false,
        isLoading: false,
    })
    const detox = (e: React.MouseEvent<HTMLElement>) =>{
        if( e.currentTarget.dataset.index ){
            selectedIndex = parseInt(e.currentTarget.dataset.index);
        } else {
            selectedIndex = 0;
        }
        setStates({...states,isLoading:true});
        Ajax.send("event/send",{play_id:props.play.id,selected:selectedIndex},(res:any)=>{
            if( res.ok ){
                if( selectedIndex===1 || selectedIndex===2 ){
                    props.gold(-1);
                }
                setStates({...states,newPlay:res.play,isLoading:false,selected:true});
            }
        })
    }
    const close = ()=>{
        props.close(states.newPlay);
    }
    const finish = ()=>{
        setStates({...states,finished:true});
    }

    useEffect( ()=>{
        selectedIndex = 0;
    },[]);

    if( states.selected ){
        return (
            <div id="event_bottles">
                <div className={classes.room}>
                {selectedIndex===0 &&
                    <span>水を買わずにベッドから降りると、販売機が不満を訴えるような排気音を鳴らした</span>
                }
                {selectedIndex===1 &&
                    <span>ベッドの上で背伸びをして販売機にコインを入れ、浴びるように水を飲んだ</span>
                }
                {selectedIndex===2 &&
                    <span>ベッドの上で背伸びをして販売機にコインを入れ、買った水を枕の横にそっと置いた</span>
                }
                {selectedIndex===3 &&
                    <span>置かれていた水を飲んだ<br/>まだかなり冷たい</span>
                }
                </div>
                <div className={classes.meters}>
                    <FourMeters stWater={props.play.water} stMagenta={props.play.magenta} stCyan={props.play.cyan} stYellow={props.play.yellow} enWater={states.newPlay.water} enMagenta={states.newPlay.magenta} enCyan={states.newPlay.cyan} enYellow={states.newPlay.yellow} finish={finish}/>
                </div>
                {states.finished &&
                <div className={classes.modalBottom}>
                    <FormControl fullWidth={true} className={classes.formControl}>
                        <Button variant="outlined" color="primary" onClick={close}>{Tools.voice()}</Button>
                    </FormControl>
                </div>
                }
            </div>
        );    
    }

    return (
        <div id="event_bottles">
            <div className={classes.room}>
            巨大な販売機がうなりをあげている<br/>
            ベッドの上に立てばコインの投入口に手が届きそうだ<br/>
            {props.param.selected===0 &&
                <div>{Tools.lover(props.play,props.param)}がベッドに上がった形跡はあるが、水は買わなかったのかも知れない</div>
            }
            {props.param.selected===1 &&
                <div>ベッドのシーツが乱れているのは、{Tools.lover(props.play,props.param)}が苦労して水を買ったためだろう</div>
            }
            {props.param.selected===2 &&
                <div>{Tools.lover(props.play,props.param)}の買った水が枕の横に置かれている<br/>まるでクリスマスのプレゼントだ</div>
            }
            販売機の中にはよく冷えた白いボトルが並んでいるのが見えた<br/>
            </div>
            <div className={classes.modalBottom}>
                <FormControl fullWidth={true} className={classes.formControl}>
                {props.param.selected===2 &&
                    <Button variant="outlined" color="primary" onClick={detox} data-index={3} style={{marginBottom:"0.2em"}}>置いてある水を飲む</Button>
                }
                    <Button variant="outlined" color="primary" onClick={detox} data-index={1} style={{marginBottom:"0.2em"}} disabled={props.play.gold===0}>買って飲む（コイン1枚）</Button>
                    <Button variant="outlined" color="primary" onClick={detox} data-index={2} style={{marginBottom:"0.2em"}} disabled={props.play.gold===0}>買って置いていく（コイン1枚）</Button>
                    <Button variant="outlined" color="primary" onClick={detox} data-index={0} style={{marginBottom:"0.2em"}}>買わない</Button>
                </FormControl>
                <Parameter play={props.play}/>
            </div>
            <Loading isLoading={states.isLoading}/>
        </div>
    );
}

export default EventMachine;
